export const generateGradientId = (value: string, prefix = 'gradient'): string => {
  return `${prefix}-${value
    .replace(/[^a-zA-Z0-9]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase()}`;
};

export const createGradientConfig = (
  id: string,
  stops = [
    { offset: '20.67%', color: '#15C3FF' },
    { offset: '100%', color: '#8DF4DB' },
  ]
) => ({
  id,
  stops,
});

export const generateActiveGradient = (value: string, prefix = 'gradient') => {
  return createGradientConfig(generateGradientId(value, prefix));
};
